import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from 'react-redux';
import store from './store';
const element = document.getElementById('zorko-media-widget');

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  element
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js